import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline'

// inner imports
import { BAND, MUSICIAN } from "../../../consts";
import { capitalizeAll, isBandFinderType } from '../../../utils';

// import css
import './horizontalsimple.css';

import notePurpleMugicsSVG from '../../inlineSVGs/notePurpleMugicsSVG';
import bandMugicsSVG from '../../inlineSVGs/bandMugicsSVG';
import {clientMedia} from "../../../Config/Settings";


class HorizontalSimple extends Component {
    constructor() {
        super();
        this.state = {
            leftItemIndex: 0
        }
    }

    getType() {
        return this.props.type === BAND ? BAND : MUSICIAN;
    }

    clickedLeft() {
        if (this.state.leftItemIndex > 0)
            this.setState({leftItemIndex: this.state.leftItemIndex - 1})
    }

    // TODO: this is very bad - create new responsive logic in the future
    clickedRight() {
        this.setState({leftItemIndex: this.state.leftItemIndex + 1})
        // if (window.innerWidth < 821 && this.state.leftItemIndex < this.props.datatypes.instruments.length + 3) {
        //     this.setState({leftItemIndex: this.state.leftItemIndex + 1});
        //     return;
        // }
        //
        // if (window.innerWidth < 1500 && this.state.leftItemIndex < this.props.datatypes.instruments.length - 3) {
        //     this.setState({leftItemIndex: this.state.leftItemIndex + 1});
        //     return;
        // }
        //
        // if (this.state.leftItemIndex < this.props.datatypes.instruments.length - 5) {
        //     this.setState({leftItemIndex: this.state.leftItemIndex + 1})
        // }
    }

    renderTypes(isAllSelected) {
        if (!this.props.datatypes || !this.props.datatypes.categories) return;

        let optionList = this.props.type === BAND ? this.props.datatypes.categories.musician : this.props.datatypes.categories.band;
        if (this.props.isOpposite) {
            optionList = this.props.type === BAND ? this.props.datatypes.categories.band : this.props.datatypes.categories.musician;
        }

        // render selected
        return optionList.map((t, index) => {
            // this is super hacky
            const nameRowsList = t.singular.split(' ');

            let nameRows = nameRowsList.map((r, i) => <p key={r + i}>{capitalizeAll(r)}</p>);

            if (this.props.selectedTypes.indexOf(t.name) > -1 || isAllSelected) {
                return (
                    <div
                        className={`looking-for-type selected ${this.getType()} ${this.props.isDark ? 'dark' : ''}`} key={index}
                        onClick={() => this.props.onUnSelect(t.name)}
                    >
                        {nameRows}
                    </div>
                )
            }

            // render not selected
            return (
                <div
                    className={`looking-for-type ${this.getType()} ${this.props.isDark ? 'dark' : ''}`} key={index}
                    onClick={() => this.props.onSelect(t)}
                >
                    {nameRows}
                </div>
            )
        })
    }

    toggleAll() {
        this.props.toggleAllTypes();

        this.forceUpdate()
    }

    renderTitle() {
        if (!this.props.isTitle) return;

        const requiredType = isBandFinderType(this.props.type) ? 'lookingForTypes' : 'instruments';

        return (
            <div
                className={`title ${this.props.type} ${(this.props.userShouldEnter && this.props.userShouldEnter.indexOf(requiredType) > -1 ? "required" : null)}`}>
                Looking for a {this.props.type === BAND ? 'cool' : 'talented'}
                {this.props.type === BAND ?
                    <SVGInline className="header-icon" svg={bandMugicsSVG}/>
                    :
                    <SVGInline className="header-icon" svg={notePurpleMugicsSVG}/>
                }
            </div>)
    }

    renderSelectAllBtn() {
        return (
            <div
                className={`select-all ${this.getType()} ${this.props.isDark ? 'dark' : ''}`}
                onClick={() => this.toggleAll()}
            >
                SELECT ALL
            </div>
        )
    }


    render () {
        if (!this.props) return null;

        return (
            <div className="horizontal-simple-wrapper">
                {this.renderTitle()}
                <div className="slider">
                    <div className="left" onClick={this.clickedLeft.bind(this)}>
                        <img src={`${clientMedia()}/img/icons/left.png`} alt="left"/>
                    </div>
                    <div className={`instruments-block ${this.getType()}`}>
                        <div className="types-wrapper" style={{transform: "translateX(-" + this.state.leftItemIndex * (window.innerWidth < 1281 ? (window.innerWidth < 821 ? 70 : 100) : 142) + "px)"}}>
                            {this.renderTypes()}
                        </div>
                    </div>
                    <div className="right" onClick={this.clickedRight.bind(this)}>
                        <img src={`${clientMedia()}/img/icons/right.png`} alt="right"/>
                    </div>
                </div>
                {!this.props.isSubmit ? this.renderSelectAllBtn() : null}
            </div>
        )
    }
}

HorizontalSimple.propTypes = {
    isTitle: PropTypes.bool,
    datatypes: PropTypes.object,
    userShouldEnter: PropTypes.array,
    type: PropTypes.string,
    onSelect: PropTypes.func,
    onUnSelect: PropTypes.func,
    selectedTypes: PropTypes.array,
    toggleAllTypes: PropTypes.func,
    isDark: PropTypes.bool,
    isOpposite: PropTypes.bool,
    isSubmit: PropTypes.bool
};

export default HorizontalSimple;



// WEBPACK FOOTER //
// ./src/Components/Elements/Carousels/HorizontalSimple.js